import MagazineHighlightTeaserWrapper from '@/components/MagazineTeaserArticleWrapper/MagazineHighlightTeaserWrapper';
import TableWrapper from '@/components/TableWrapper/TableWrapper';
import ButtonLink from '@uikit/components/ButtonLink/ButtonLink';
import ComponentList from '@uikit/components/ComponentList/ComponentList';
import ContactBlock from '@uikit/components/ContactBlock/ContactBlock';
import ContactTelephone from '@uikit/components/ContactTelephone/ContactTelephone';
import Container from '@uikit/components/Container/Container';
import Download from '@uikit/components/Download/Download';
import Group from '@uikit/components/Group/Group';
import Headline from '@uikit/components/Headline/Headline';
import Image from '@uikit/components/Image/Image';
import ImageMap from '@uikit/components/ImageMap/ImageMap';
import InfoBox from '@uikit/components/InfoBox/InfoBox';
import LottieWrapper from '@uikit/components/LottieWrapper/LottieWrapper';
import MagazineArticleHeader from '@uikit/components/Magazine/MagazineArticleHeader/MagazineArticleHeader';
import MagazineCategoryTeaser from '@uikit/components/Magazine/MagazineCategoryTeaser/MagazineCategoryTeaser';
import MagazineFaq from '@uikit/components/Magazine/MagazineFaq/MagazineFaq';
import MagazineFavoriteArticles from '@uikit/components/Magazine/MagazineFavoriteArticles/MagazineFavoriteArticles';
import MagazineHeroCarousel from '@uikit/components/Magazine/MagazineHeroCarousel/MagazineHeroCarousel';
import MagazineHeroCarouselItem from '@uikit/components/Magazine/MagazineHeroCarousel/MagazineHeroCarouselItem';
import MagazineImageSlider from '@uikit/components/Magazine/MagazineImageSlider/MagazineImageSlider';
import MagazinePrintTeaser from '@uikit/components/Magazine/MagazinePrintTeaser/MagazinePrintTeaser';
import MagazineCategoryArea from '@uikit/components/MagazineCategoryArea/MagazineCategoryArea';
import MagazineGridWrapper from '@uikit/components/MagazineGridWrapper/MagazineGridWrapper';
import ProductTeaser from '@uikit/components/ProductTeaser/ProductTeaser';
import RichText from '@uikit/components/RichText/RichText';
import Section from '@uikit/components/Section/Section';
import Teaser from '@uikit/components/Teaser/Teaser';
import TeaserTile from '@uikit/components/TeaserTile/TeaserTile';
import TeaserTileLarge from '@uikit/components/TeaserTileLarge/TeaserTileLarge';
import TeaserWithImage from '@uikit/components/TeaserWithImage/TeaserWithImage';
import TwoColumnContainer from '@uikit/components/TwoColumnContainer/TwoColumnContainer';
import VideoWrapper from '@uikit/components/Video/Video.wrapper';
import MagazineQuoteWrapper from '@uikit/composites/MagazineQuoteWrapper/MagazineQuoteWrapper';
import React from 'react';
import MagazineAmazingNumberWrapper from '../components/MagazineAmazingNumberWrapper/MagazineAmazingNumberWrapper';
import MagazineArticleDetailsWrapper from '../components/MagazineArticleDetailsWrapper/MagazineArticleDetailsWrapper';
import MagazineRelatedArticlesWrapper from '../components/MagazineRelatedArticlesWrapper/MagazineRelatedArticlesWrapper';
import MagazineTeaserArticleWrapper from '../components/MagazineTeaserArticleWrapper/MagazineTeaserArticleWrapper';
import MagazineAdditionalContents from '../uikit/components/Magazine/MagazineAdditionalContents/MagazineAdditionalContents';

export const CmsComponentsMagazine = {
  'magazine-article-details-area': React.Fragment,
  'magazine-article-details': MagazineArticleDetailsWrapper,
  'magazine-article-header': MagazineArticleHeader,
  'magazine-section': Section,
  'magazine-container': Container,
  'magazine-two-sided-box-container': TwoColumnContainer,
  'magazine-amazing-number': MagazineAmazingNumberWrapper,
  'magazine-image-slider': MagazineImageSlider,
  'magazine-related-articles-area': React.Fragment,
  'magazine-related-articles': MagazineRelatedArticlesWrapper,
  'magazine-faq': MagazineFaq,
  'magazine-teaser-article': MagazineTeaserArticleWrapper,
  'magazine-highlight-article': MagazineHighlightTeaserWrapper,
  'magazine-grid': MagazineGridWrapper,
  'magazine-highlight': MagazineHighlightTeaserWrapper,
  'magazine-hero-slider-area': MagazineHeroCarousel,
  'magazine-hero-slider-slide': MagazineHeroCarouselItem,
  'magazine-category-teaser': MagazineCategoryTeaser,
  'magazine-favorite-articles': MagazineFavoriteArticles,
  'magazine-favorite-articles-area': React.Fragment,
  'magazine-category-wrapper-area': React.Fragment,
  'magazine-category-area': MagazineCategoryArea,
  'contents-magazine-category-area-slot-1': React.Fragment,
  'contents-magazine-category-area-slot-2': React.Fragment,
  'contents-magazine-category-area-slot-3': React.Fragment,
  'magazine-button': ButtonLink,
  'magazine-rich-text': RichText,
  'magazine-quote': MagazineQuoteWrapper,
  'magazine-image': Image,
  'magazine-contact-block': ContactBlock,
  'magazine-video': VideoWrapper,
  'magazine-component-list': ComponentList,
  'magazine-table': TableWrapper,
  'magazine-download-bar': Download,
  'magazine-info-box': InfoBox,
  'magazine-headline': Headline,
  'magazine-article-headline': Headline,
  'magazine-group': Group,
  'image-map-custom': ImageMap,
  'magazine-lottie-magnolia': LottieWrapper,
  'magazine-contact-telephone': ContactTelephone,
  'magazine-teaser': Teaser,
  'magazine-teaser-tile': TeaserTile,
  'magazine-teaser-tile-large': TeaserTileLarge,
  'magazine-teaser-with-image': TeaserWithImage,
  'magazine-additional-contents': MagazineAdditionalContents,
  'magazine-additional-content-container': Container,
  'magazine-additional-content-two-column-container': TwoColumnContainer,
  'magazine-print-teaser': MagazinePrintTeaser,
  'product-teaser': ProductTeaser,
};
